// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._11c81bk4{font:var(--ds-font-heading-small,normal 600 1pc/20px ui-sans-serif,-apple-system,BlinkMacSystemFont,\"Segoe UI\",Ubuntu,system-ui,\"Helvetica Neue\",sans-serif)}\n._18u0idpf{margin-left:0}\n._19pkidpf{margin-top:0}\n._2hwxidpf{margin-right:0}\n._otyridpf{margin-bottom:0}\n._syaz1fxt{color:var(--ds-text,#172b4d)}", ""]);
// Exports
module.exports = exports;
